import { createContext, useState } from 'react';
import SessionService from '../services/SessionService';

const LoginContext = createContext({
  authenticated: false,
  setAuthenticated: auth => {},
});

export const LoginProvider = props => {
  const [authenticated, setAuthenticated] = useState(
    SessionService.isAuthenticated()
  );
  return (
    <LoginContext.Provider value={{ authenticated, setAuthenticated }}>
      {props.children}
    </LoginContext.Provider>
  );
};

export default LoginContext;
